import React, { useRef } from 'react';
import { HashLink } from 'react-router-hash-link';
import { Link, useLocation } from 'react-router-dom';
import anmaticsLogo from '../images/new/logo-ui.png';

const Header = () => {
    // Expand nav menu on mobile view and when click on nav link hide the menu
    const navButton = useRef(null);
    const linksContainerRef = useRef(null);

    // Use React Router's useLocation hook to get current route
    const location = useLocation();

    function collapseNav() {
        navButton.current.classList.add("collapsed");
        linksContainerRef.current.classList.remove("show");
    }

    // Helper to check if a link is active
    function isActive(to) {
        if (to.startsWith('/#')) {
            // For hash links, check if we're on home page and hash matches
            const targetHash = to.replace('/#', '#');
            return location.pathname === '/' && location.hash === targetHash;
        }
        // For regular routes, check pathname
        return location.pathname === to;
    }

    // Helper to handle click and set active link
    function handleNavClick(to) {
        collapseNav();
    }

    return (
        <header className="header-section fixed-top shadow-sm">
            <nav className="navbar navbar-expand-lg" style={{ background: 'var(--anmatics-light-bg)', backdropFilter: 'blur(8px)' }}>
                <div className="container">
                    <HashLink className="navbar-brand d-flex align-items-center brand-link" to="/#home">
                        <img
                            src={anmaticsLogo}
                            alt="Anmatics Technologies logo"
                            className="logo-img"
                            width="52"
                            height="52"
                            decoding="async"
                            fetchPriority="high"
                        />
                        <span className="brand-text">Anmatics</span>
                        <sup className="brand-reg">®</sup>
                    </HashLink>
                    <button
                        ref={navButton}
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        style={{ border: 'none', outline: 'none' }}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav" ref={linksContainerRef}>
                        <ul className="navbar-nav ms-auto align-items-center nav-list">
                            <li className="nav-item">
                                <HashLink
                                    onClick={() => handleNavClick('/#home')}
                                    className={`nav-link-thematic${isActive('/#home') ? ' active' : ''}`}
                                    aria-current={isActive('/#home') ? 'page' : undefined}
                                    to="/#home"
                                >Home</HashLink>
                            </li>
                            <li className="nav-item">
                                <HashLink
                                    onClick={() => handleNavClick('/#about')}
                                    className={`nav-link-thematic${isActive('/#about') ? ' active' : ''}`}
                                    to="/#about"
                                    smooth
                                >About</HashLink>
                            </li>
                            <li className="nav-item">
                                <HashLink
                                    onClick={() => handleNavClick('/#services')}
                                    className={`nav-link-thematic${isActive('/#services') ? ' active' : ''}`}
                                    to="/#services"
                                    smooth
                                >Services</HashLink>
                            </li>
                            <li className="nav-item">
                                <Link
                                    onClick={() => handleNavClick('/products')}
                                    className={`nav-link-thematic${isActive('/products') ? ' active' : ''}`}
                                    to="/products"
                                >Products</Link>
                            </li>
                            <li className="nav-item">
                                <HashLink
                                    onClick={() => handleNavClick('/#contact')}
                                    className={`nav-link-thematic${isActive('/#contact') ? ' active' : ''}`}
                                    to="/#contact"
                                    smooth
                                >Contact</HashLink>
                            </li>
                            <li className="nav-item">
                                <Link
                                    onClick={() => handleNavClick('/blogs')}
                                    className={`nav-link-thematic${isActive('/blogs') ? ' active' : ''}`}
                                    to="/blogs"
                                >Blogs</Link>
                            </li>
                            <li className="nav-item d-none d-lg-block">
                                <Link to="/contact" className="btn btn-gradient fw-bold px-4 py-2 ms-2 rounded-pill shadow-sm">
                                    Book Consultation
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
